import React, {useEffect, useRef, useState} from "react";
import { Form } from "react-bootstrap";
import IconTooltip from "../../../assets/images/eoro-2024/icon-tooltip.svg";
import IconGreen from "../../../assets/images/eoro-2024/icon-green.svg";
import IconRed from "../../../assets/images/eoro-2024/icon-red.svg";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import GroupCard from "./GroupCard";


const GroupTopAndBottomTeams = (props) => {
    const {
        isMobile,
        leagueGroups,
        groupPositions,
        setGroupPositions,
        edit,
        myGroupPositions,
    } = props;

    const [show, setShow] = useState(false);
    const target = useRef(null);

    const handleUpdateGroupPositions = (groupName, updatedPositions) => {
        setGroupPositions(prevPositions => {
            const updatedIndex = prevPositions?.findIndex(group => group?.name === groupName);
            if (updatedIndex !== -1) {
                prevPositions[updatedIndex] = { name: groupName, ...updatedPositions };
                return [...prevPositions];
            } else {
                return [...prevPositions, { name: groupName, ...updatedPositions }];
            }
        });
    };



    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                <div className={"d-flex flex-column gap-1 align-items-start justify-content-start"}>
                    <div className={"cabin fw-700 font-20"}>Team Selection</div>
                    <div className={"d-flex gap-1"}>
                        <img
                            src={IconGreen}
                            className="img-fluid"
                            alt="icon"
                        />
                        <div className={"text-nowrap cabin fw-700 font-16"}>Green Highlight = Top Team</div>
                    </div>
                    <div className={"d-flex gap-1"}>
                        <img
                            src={IconRed}
                            className="img-fluid"
                            alt="icon"
                        />
                        <div className={"text-nowrap cabin fw-700 font-16"}>Red Highlight = Bottom Team</div>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-row align-items-center justify-content-center gap-2 mt-1 mb-2"}>
                        <div className={`cabin fw-700 font-14 ${edit ? "text-skins-blue":"text-white"}`}>
                            {edit ? "Edit" : "Select"} Your Top & Bottom Team From Each Group
                        </div>
                        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                            <div role={"button"} ref={target} onClick={() => setShow(!show)}>
                                <img
                                    src={IconTooltip}
                                    className="img-fluid"
                                    alt="icon"
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className={"my-2"}>
                    <div className={"d-flex gap-3 align-items-center justify-content-center flex-wrap w-100"}>
                        {leagueGroups?.map((group, index) => (
                            <GroupCard
                                key={index}
                                isMobile={isMobile}
                                group={group}
                                onUpdateGroupPositions={(groupName, updatedPositions) => handleUpdateGroupPositions(groupName, updatedPositions)}
                                myGroupPositions={myGroupPositions}
                                edit={edit}
                            />
                        ))}
                    </div>
                </div>

            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-row align-items-center justify-content-center gap-2"}>
                        <div className={"cabin fw-700 font-20 text-white"}>
                            {edit ? "Edit" : "Select"} Your Top & Bottom Team From Each Group
                        </div>
                        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                            <div role={"button"} ref={target} onClick={() => setShow(!show)}>
                                <img
                                    src={IconTooltip}
                                    className="img-fluid"
                                    alt="icon"
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className={"my-4"}>
                    <div className={"d-flex align-items-center justify-content-evenly flex-wrap"}>
                        {leagueGroups?.map((group, index) => (
                            <GroupCard
                                key={index}
                                isMobile={isMobile}
                                group={group}
                                onUpdateGroupPositions={(groupName, updatedPositions) => handleUpdateGroupPositions(groupName, updatedPositions)}
                                myGroupPositions={myGroupPositions}
                                edit={edit}
                            />
                        ))}
                    </div>
                </div>
            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default GroupTopAndBottomTeams;
